import React from 'react';
import { Boxes } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  title, 
  description, 
  action,
  icon = <Boxes className="h-12 w-12 text-gray-400" />
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 border border-gray-100">
      <div className="text-center">
        <div className="mx-auto mb-4">
          {icon}
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-gray-500 mb-6 max-w-md mx-auto">
          {description}
        </p>
        {action}
      </div>
    </div>
  );
};

export default EmptyState;